import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    cardContainer: {
        padding: '20px'
    },
    headerContainer: {
        marginTop: '-20px',
        padding: '12px',
        background: Colors.GRAY_BACKGROUND,
    },
    headerTitle: {
        fontWeight: 'bold'
    },
    dropdownContainer: {
        margin: '12px 0',
        padding: '12px',
        background: Colors.GRAY_BACKGROUND
    },
    dropdownContainerSelected: {
        margin: '12px 0',
        padding: '12px',
        background: Colors.DARK_GRAY_BACKGROUND
    },
    dropdown: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    title: {
        width: '170px',
        color: Colors.DARK_BLUE
    },
    titleSelected: {
        width: '180px',
        fontWeight: 'bold',
        color: Colors.DARK_BLUE
    },
    arrowBtn: {
        color: '#FFA500'
    },
    closeBtn: {
        display: 'flex',
        justifyContent: 'center'
    },
    cardChild: {
        marginBottom: '12px',
    },
    chartContainer: {
        padding: '20px 20px 0',
        marginBottom: '20px'
    }

}))

export default useStyles